<template>
    <!--
        公司：江西敏讯科技智能科技有限公司
        作者：朱云
        时间：2021/04/20
        描述：智联网
    -->
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App',
    }
</script>

<style lang="scss">
    @import "assets/css/iconfont.css";

    * {
        margin: 0;
        padding: 0;
        font-size: 18px;
    }

    #app {
        font-family: Microsoft YaHei;
        text-align: center;
        color: #2c3e50;
    }

    .overflow {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .flex {
        display: flex;
    }

    .flex-column {
        flex-direction: column;
    }

    .space-between {
        justify-content: space-between;
    }

    .space-around {
        justify-content: space-around;
    }

    .space-center {
        justify-content: center;
    }

    .flex-start {
        justify-content: flex-start;
    }

    .flex-end {
        justify-content: flex-end;
    }

    .flex-warp {
        flex-wrap: wrap;
    }

    .element-center {
        display: flex;
        align-self: center;
    }

    .flex-1 {
        flex: 1;
    }
    .align-center {
        align-items: center;
    }

    /*表格样式*/
    .el-table, .el-table__expanded-cell {
        background-color: transparent !important;
    }

    .el-table th.is-leaf {
        background-color: transparent !important;
        border-bottom: none !important;
    }

    .el-table tr, .el-table th {
        background-color: transparent !important;
    }

    .personnel-table .cell {
        /*background-color: rgba(0, 228, 255, 0.4);*/

        color: #FFF;
    }


    .personnel-table .el-table__row {
        /*background-color: rgba(0, 228, 255, 0.4) !important;*/
    }

    .personnel-table td {
        border-bottom: 1px solid #8EE3FF !important;
    }

    .personnel-table th.is-leaf {
        border-bottom: 1px solid #8EE3FF !important;

    }

    .personnel-table th.is-leaf .cell {
        /*color: #00E4FF;*/
        background-color: transparent !important;
    }

    .el-table--enable-row-hover .el-table__body tr:hover > td {
        background-color: transparent !important;
        /* color: #f19944; */
        /* 设置文字颜色，可以选择不设置 */
    }

    .el-table td, .is-leaf {
        /*border-bottom: 0 !important;*/
    }

    .el-table .gutter {
        width: 0 !important;
    }

    .el-table .el-table__body-wrapper::-webkit-scrollbar {
        /* width: 0;宽度为0隐藏 */
        width: 0px;
        height: 0;
    }

    .el-table .el-table__empty-text{
        color: white;
    }
    .el-table::before {
        background-color: transparent !important;
    }

    .business-table td, .is-leaf {
        border-bottom: 1px solid #8EE3FF !important;
    }

    .business-table .has-gutter th {
        background-color: rgba(0, 228, 255, 0.4) !important;
        color: #FFF;
    }

    .business-table .el-table__row {
        color: #CCC;
    }
</style>
